import Head from 'next/head';
import { Row, Col } from 'antd';
import type { GetServerSideProps } from 'next';
import { withApollo } from '$apollo/hooks';
import CustomerLayout from '$layout/CustomerLayout';
import { ForgotPasswordContainer } from '$pages/forgot-password';
import { withServerSkipPageIfAuthenticated } from '$util/identity';
import { useAppContext } from '$util/AppContext';
import { getShortTextByKey } from '$cms/getDataByKey';
import { getMetaTitle } from '$components/pages/gql';
import { GET_FORGOT_PASSWORD_CMS } from '$components/pages/forgot-password/gql';

function ForgotPasswordPage() {
  const AppContext = useAppContext();
  const {
    cmsContent: { dictionary },
  } = AppContext;
  const getShortText = getShortTextByKey.bind(dictionary);
  const pageTitle = getShortText('metaTitle.customer.forgotPassword', 'Forgot Password | Fixter');

  return (
    <CustomerLayout>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <Row>
        <Col>
          <ForgotPasswordContainer />
        </Col>
      </Row>
    </CustomerLayout>
  );
}

export const getServerSideProps: GetServerSideProps = withServerSkipPageIfAuthenticated([
  GET_FORGOT_PASSWORD_CMS,
  getMetaTitle,
]);

export default withApollo(ForgotPasswordPage);
